import React, { useEffect, useRef, useState } from 'react';

import styles from './DuplicateAction.module.css';
import BlockDestinationPosition from '../../../../../../SidePropertiesContainer/components/Action/components/BlockDestinationPosition/BlockDestinationPosition';
import ConstraintTooltip from '../../../../../../ConstraintTooltip/ConstraintTooltip';

export default function({
  isActionAllowed,
  isActionAllowedChecker,
  onActionClick,
  icon,
  propertiesComponent,
  label,
  onDoneButtonPress
}) {
  const triggerRef = useRef(null);
  const contentRef = useRef(null);
  const [showPropertiesComponent, setShowPropertiesComponent] = useState(false);

  useEffect(() => {
    function isInside(ref, event) {
      const node = ref.current;
      if (!node) return false;

      if (node.contains(event.target)) return true;

      const path =
        typeof event.composedPath === 'function' ? event.composedPath() : [];

      return path.includes(node);
    }

    function handleOutsideDropdownClick(event) {
      const insideTrigger = isInside(triggerRef, event);
      const insideContent = isInside(contentRef, event);

      if (!insideTrigger && !insideContent) {
        setShowPropertiesComponent(false);
      }
    }

    document.addEventListener('click', handleOutsideDropdownClick);

    return () => {
      document.removeEventListener('click', handleOutsideDropdownClick);
    };
  }, []);

  const renderPropertiesComponent = () => {
    if (propertiesComponent === 'BlockDestinationPosition') {
      return (
        <div className={styles.blockDestinationContainer}>
          <BlockDestinationPosition
            contentRef={contentRef}
            setShowPropertiesComponent={setShowPropertiesComponent}
            onDoneButtonPress={onDoneButtonPress}
            isActionAllowedChecker={isActionAllowedChecker}
          />
        </div>
      );
    }
    return null;
  };

  const onClick = () => {
    if (onActionClick) {
      onActionClick();
    }

    if (propertiesComponent) {
      if (!showPropertiesComponent) {
        setShowPropertiesComponent(true);
      } else {
        setShowPropertiesComponent(false);
      }
    }
  };

  return (
    <div ref={triggerRef}>
      <div
        role="presentation"
        className={styles.container}
        onClick={e => {
          e.stopPropagation();

          if (isActionAllowed && isActionAllowed.allowed === true) {
            onClick();
          }
        }}
      >
        <div
          className={
            isActionAllowed && isActionAllowed.allowed !== true
              ? styles.notAllowed
              : ''
          }
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {icon}
          {label}
        </div>
        {isActionAllowed && isActionAllowed.allowed !== true ? (
          <ConstraintTooltip label={isActionAllowed.message} />
        ) : null}
      </div>
      {showPropertiesComponent ? renderPropertiesComponent() : null}
    </div>
  );
}
